import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Activity } from "lucide-react";

const dot = {
  LIVE: "bg-bullish", ONLINE: "bg-bullish", AVAILABLE: "bg-bullish", HEALTHY: "bg-bullish",
  DEMO: "bg-warning", DELAYED: "bg-warning", DEGRADED: "bg-warning",
  OFFLINE: "bg-bearish", UNAVAILABLE: "bg-bearish",
};

export function SystemStatus({ inline = false }) {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    api.get("/system/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);
  if (!status) return null;
  const items = [
    ["Market Data", status.market_data],
    ["AI", status.ai],
    ["Payments", status.payments],
    ["API", status.api],
  ];
  if (inline) {
    return (
      <div className="flex items-center gap-1.5 text-xs" data-testid="system-status-inline">
        <span className={`h-2 w-2 rounded-full ${dot[status.market_data] || "bg-muted-foreground"} animate-pulse`} />
        <span className="font-mono uppercase tracking-wider text-muted-foreground">{status.market_data}</span>
      </div>
    );
  }
  return (
    <div className="rounded-xl border border-border bg-card p-4" data-testid="system-status-panel">
      <div className="mb-3 flex items-center gap-2 text-sm font-semibold">
        <Activity className="h-4 w-4 text-accent" /> System Status
      </div>
      <div className="space-y-2">
        {items.map(([label, val]) => (
          <div key={label} className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">{label}</span>
            <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-wider">
              <span className={`h-2 w-2 rounded-full ${dot[val] || "bg-muted-foreground"}`} />
              {val}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
